import GovPlatformPage from './pages/GovPlatform';

export default [{
    path: '/hr/gov-platform',
    title: '实名制云平台',
    component: GovPlatformPage
}]